export default __webpack_public_path__ + "static/media/Bracers of the Silent Slayer.2827555e.jpg";